export default __webpack_public_path__ + "EUs_verify.html";